"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "uboldo": {
    "ee674f3c": [{
      "hkey": "e4b14324",
      "slug": "uboldo",
      "name": "Uboldo",
      "primary": true,
      "skipSearch": false
    }],
    "boschi": [{
      "hkey": "e4b14324",
      "slug": "uboldo",
      "name": "Uboldo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b3b30a9b": [{
      "hkey": "e4b14324",
      "slug": "uboldo",
      "name": "Uboldo",
      "primary": true,
      "skipSearch": false
    }],
    "lazzaretto": [{
      "hkey": "e4b14324",
      "slug": "uboldo",
      "name": "Uboldo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "35477c82": [{
      "hkey": "e4b14324",
      "slug": "uboldo",
      "name": "Uboldo",
      "primary": true,
      "skipSearch": false
    }],
    "madonna-del-soccorso": [{
      "hkey": "e4b14324",
      "slug": "uboldo",
      "name": "Uboldo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0fdc41ef": [{
      "hkey": "e4b14324",
      "slug": "uboldo",
      "name": "Uboldo",
      "primary": true,
      "skipSearch": false
    }],
    "madonnina": [{
      "hkey": "e4b14324",
      "slug": "uboldo",
      "name": "Uboldo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;